export const hexToRGBA = (hex, alpha) => {
  let hexOption = hex;
  if (hexOption.length === 4) {
    hexOption = `${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}}`;
  }
  const RR = parseInt(hexOption.slice(1, 3), 16);
  const GG = parseInt(hexOption.slice(3, 5), 16);
  const BB = parseInt(hexOption.slice(5, 7), 16);

  return `rgba(${RR}, ${GG}, ${BB}${alpha && `, ${alpha}`})`;
};

export const transformOpacity = (input) => {
  const numberInput = parseInt(input, 10);

  if (isNaN(numberInput) || numberInput < 0 || numberInput > 100) {
    throw new Error('Invalid input. Please input a number from 0 to 100.');
  }

  return numberInput / 100;
};
